import { useRouter } from 'next/router';
import {
  Description,
  Metadata,
  Tags,
  Title,
} from '@/creditflowresearch/ui/common/components/CreditFlowResearch/CreditFlowData';
import { useStatContext } from '@/creditflowresearch/application/ArticlesAndStats/Stat';
import PageMeta from '@/creditflowresearch/ui/common/components/PageMeta';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';
import getStatMetaSchema from './getStatMetaSchema';

import styles from '@/creditflowresearch/ui/components/creditFlow/common/styles.module.scss';

const StatContent = () => {
  const { stat } = useStatContext();
  const {
    name,
    author,
    updatedAt: date,
    categories,
    description,
    preview,
  } = stat;
  const { asPath: pathname } = useRouter();
  const { timeZone } = useUserTimeZoneContext();

  return (
    <>
      <PageMeta
        title={ name }
        schema={ getStatMetaSchema(pathname, stat) }
      />
      <div className={ styles.creditFlowContent }>
        <Metadata
          author={ author.name }
          date={ date }
          timeZone={ timeZone }
          authorDataTest="statAuthor"
          dateDataTest="statDate"
        />
        <Title title={ name } dataTest="statName" />
        <div className={ styles.flexWithGap }>
          <Tags
            tags={ categories.map((category) => category.displayName) }
            dataTest="statCategories"
            tagDataTest="statCategory"
          />
          <Description
            description={ description }
            className={ styles.description }
            dataTest="statDescription"
          />
          { preview && (
            <div data-test="statImagePreview">
              <img
                src={ preview.url }
                alt="Stat preview"
              />
            </div>
          ) }
        </div>
      </div>
    </>
  );
};

export default StatContent;
